import React from 'react'
import { useState } from 'react'
import {
  Box,
  Grid,
  Typography, CircularProgress, Tab, Tabs,
} from '@mui/material'
import Header from '../UI/Header'
import { useTheme } from '@mui/material/styles'

import 'dayjs/locale/it';
import AccountingAdv from './components/accounting/AccountingAdv'
import AccountingMonitoraggio from './components/accounting/AccountingMonitoraggio'



const Accounting = () => {
  const theme = useTheme()


  const [tabIndex, setTabIndex] = useState(0)

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue)
  }

  return (
    <div>
      <Header
        showHome={true}
        showRichiesta
        showStatistiche={false}
        header={
          <Grid
            container
            columns={{ xs: 4, sm: 8, md: 12 }}
            justifyContent="center"
            alignContent="center"
            sx={{
              textAlign: 'center',
              height: '100px', // Imposta l'altezza desiderata
            }}
          >
            <Typography
              sx={{ flexGrow: 1 }}
              xs={12}
              item
              alignItems="center"
              color={theme.palette.black.main}
              variant="h1"
            >
              ACCOUNTING
            </Typography>
          </Grid>
        }
      />
      <Box sx={{ width: '100%' }}>
        <Tabs value={tabIndex} onChange={handleTabChange} centered>
          <Tab label="Adeguata Verifica" />
          <Tab label="Monitoraggio" />
        </Tabs>

        {tabIndex === 0 && (
          <Box p={3}>
            <AccountingAdv />
          </Box>
        )}
        {tabIndex === 1 && (
          <Box p={3}>
            <AccountingMonitoraggio />
          </Box>
        )}
      </Box>
      {/*<Grid
        container
        mt={{ xs: 15, lg: 8, xl: 8 }}
        spacing={5}
        columns={{ xs: 4, sm: 8, md: 12 }}
        justifyItems="space-between"
      >
        {!props.onlySintesi && (<>
          <Grid item xs={12} sx={{ marginTop: 10 }}>
            {searchPerformed ? (
              <Box sx={{ padding: 5, width: '100%', height: { xs: '500px', xl: '650px' } }}>
                <ResultsTableAccounting
                  listaPratiche={listaPratiche}

                  isFetchedListaPratiche={isFetchedListaPratiche}
                  refetchListaPratiche={refetchListaPratiche}
                  isFetchingListaPratiche={fetchingData}
                />
              </Box>
            ) : (

              <Box sx={{ padding: 5, width: '100%', height: { xs: '500px', xl: '650px' } }}>

                <ResultsTableAccounting
                  listaPratiche={[]} // Inizializza con un array vuoto

                  isFetchedListaPratiche={false}
                  refetchListaPratiche={refetchListaPratiche}
                  isFetchingListaPratiche={false}
                />
              </Box>
            )}
          </Grid>
        </>)}
        {props.onlySintesi && (<>

          {!fetchingData && (
            <Grid item xs={12} sx={{ marginTop: 15, marginLeft: 5 }}>
              <ReportAccountingTable reportAccounting={reportAccounting} />
            </Grid>
          )}

        </>)}
      </Grid>*/}
    </div>
  );
}

export default Accounting;

